<button
  data-test="capra-logo-button"
  class="logo-button"
  [class.logo-button-clickable]="hamburgerState"
  (click)="onClick()"
>
  <capra-icon
    class="logo-icon"
    [icon]="isAnalystStudio ? (theme === 'dark' ? 'illo-ts-logo-white' : 'illo-ts-logo-black') : 'icon-mode-logo'"
    height="24px"
    width="24px"
  ></capra-icon>
  <div
    *ngIf="hamburgerState && isAnalystStudio === false"
    data-test="capra-logo-button-hamburger"
    class="hamburger"
    [class.hamburger-collapsed]="hamburgerState === 'collapsed'"
    [class.hamburger-expanded]="hamburgerState === 'expanded'"
  ></div>
</button>
